import useAsyncData from "../../../../hooks/use-async-data";
import billingService from "../../billings.service";
import BillingsCargoTaxiDetails from "./billings-cargo-taxi-details";
import BillingsCargoTaxiDetailsParams from "./billings-cargo-taxi-details-params";

const useBillingsCargoTaxiDetails = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsCargoTaxiDetails | null>(null);

  const load = async (
    params: BillingsCargoTaxiDetailsParams,
    abortSignal: AbortSignal,
  ): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await billingService.getCargoTaxiBillingsDetails(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useBillingsCargoTaxiDetails;
